<template>
  <div v-loading="loading">
    <div class="flex justify-end">
      <base-button
        class="w-full lg:w-1/5"
        @click="$router.push({ name: 'NewDoorToDoorRoute' })"
        text="New Route"
        v-if="$_isAdmin"
      />
    </div>
    <pre>
    <!-- {{paginatedList}} -->
  </pre>
    <div v-if="!loading && filteredRoutes.length == 0" class="lg:hidden mt-5">
      <div class="flex flex-col justify-center items-center gap-4">
        <empty-route-icon />

        <p>No Route to display.</p>

        <div
          class="flex gap-2 text-primary-yellow text-center text-sm font-bold cursor-pointer"
          @click="$router.push({ name: 'NewRoute' })"
        >
          <span>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="#FCC210"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                fill="#FCC210"
              />
            </svg>
          </span>
          Start Adding Route
        </div>
      </div>
    </div>

    <div
      v-for="route in paginatedList"
      :key="route.id"
      class="lg:hidden grid grid-cols-2 p-4 mb-4 bg-white rounded-2xl mt-3"
    >
      <div>
        <p
          :style="{ color: '#979797' }"
          class="flex gap-2 text-xs font-semibold"
        >
          <LocationIcon class="mt-1 mr-1" />
          STATE
        </p>
        <p class="ml-4 text-xs">
          {{ route.state }}
        </p>
      </div>

      <div>
        <div class="flex justify-between gap-2">
          <div
            class="rounded-lg px-3 py-1 text-xs text-center"
            :style="{
              height: '24px',
              width: '85px',
              'background-color': route.isPrimary ? '#09B78A1A' : '#FCC2101A',
              color: route.isPrimary ? '#09B78A' : '#FCC210',
            }"
          >
            {{ route.isPrimary ? "Primary" : "Secondary" }}
          </div>

          <el-dropdown   v-if="$_isAdmin">
            <button>
              <vertical-ellipsis />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button class="flex items-center">
                  <div class="cursor-pointer" @click="viewRoute(route.id)">
                    <p>View & Edit</p>
                  </div>
                </button>
              </el-dropdown-item>

              <el-dropdown-item>
                <div
                  v-if="route.isActive"
                  class="cursor-pointer"
                  @click="deactivateRoute(route.id)"
                >
                  <p>Deactivate</p>
                </div>
                <div
                  v-else
                  class="cursor-pointer"
                  @click="activateRoute(route.id)"
                >
                  <p>Activate</p>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="mt-3">
        <p
          :style="{ color: '#979797' }"
          class="flex gap-2 text-xs font-semibold"
        >
          <LocationIcon class="mt-1 mr-1" />
          ORIGINATING TERMINAL
        </p>
        <p class="ml-4 text-xs">
          {{ route.takeOff ? route.takeOff.locationName : "N/A" }}
        </p>
      </div>

      <div class="mt-3">
        <p
          :style="{ color: '#979797' }"
          class="flex gap-2 text-xs font-semibold"
        >
          <LocationIcon class="mt-1 mr-1" />
          ROUTES
        </p>
        <p
          @click="
            (viewSelected = true), (selectedRouteCities = route.routeCities)
          "
          class="ml-4 text-xs underline decoration-sky-500 text-sky-400"
        >
          {{ route.routeCities.length || 0 }}
        </p>
      </div>

      <div class="mt-3">
        <p
          :style="{ color: '#979797' }"
          class="flex gap-2 text-xs font-semibold"
        >
          <LocationIcon class="mt-1 mr-1" />
          LAST MODIFIED
        </p>
        <p class="ml-4 text-xs">
          <span>{{ route.createdAt | formatDate }} </span> <br />
          <span
            >{{ route.user ? route.user.firstname : "" }}
            {{ route.user ? route.user.lastname : "" }}</span
          >
        </p>
      </div>

      <div class="mt-3">
        <p
          :style="{ color: '#979797' }"
          class="flex gap-2 text-xs font-semibold"
        >
          <LocationIcon class="mt-1 mr-1" />
          STATUS
        </p>
        <p class="ml-4 mt-2 text-xs">
          <span class="active" v-if="route.isActive"> Active </span>
          <span class="inactive" v-else>Inactive</span>
        </p>
      </div>
    </div>

    <div class="hidden lg:block">
      <table class="custom-table responsive-table">
        <thead>
          <tr class="shadow-table rounded-md">
            <th>State</th>
            <th>Originating Terminal</th>
            <th>Routes</th>
            <th>Last Modified</th>
            <th>Status</th>
            <th><img src="@/assets/images/icons/options-icon.png" alt="" /></th>
          </tr>
        </thead>

        <tbody v-if="!loading && filteredRoutes.length == 0">
          <tr>
            <td class="shadow-table rounded-md" colspan="7">
              <div class="flex flex-col justify-center items-center gap-4">
                <empty-route-icon />

                <p>No Route to display.</p>

                <div
                  class="flex gap-2 text-primary-yellow text-center text-sm font-bold cursor-pointer"
                  @click="$router.push({ name: 'NewRoute' })"
                >
                  <span>
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="#FCC210"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                        fill="#FCC210"
                      />
                    </svg>
                  </span>
                  Start Adding Route
                </div>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody class="" v-if="!loading && filteredRoutes.length">
          <tr
            v-for="route in paginatedList"
            :key="route.id"
            class="shadow-table my-2 rounded-md"
          >
            <td>
              <span>{{ route.state }}</span>
            </td>

            <td>
              {{ route.takeOff ? route.takeOff.locationName : "N/A" }}
            </td>
            <td>
              <span
                @click="
                  (viewSelected = true),
                    (selectedRouteCities = route.routeCities)
                "
                class="underline decoration-sky-500 text-sky-400"
                >{{ route.routeCities.length || 0 }}</span
              >
            </td>

            <td>
              <span>{{ route.createdAt | formatDate }} </span> <br />
              <span
                >{{ route.user ? route.user.firstname : "" }}
                {{ route.user ? route.user.lastname : "" }}</span
              >
            </td>
            <td>
              <span class="active" v-if="route.isActive"> Active </span>
              <span class="inactive" v-else>Inactive</span>
            </td>

            <td
              tabindex="-1"
              @blur="selectedRowId = null"
              class="table__action-btn cursor-pointer"
            >
              <el-dropdown v-if="$_isAdmin">
                <button>
                  <vertical-ellipsis />
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <button class="flex items-center">
                      <div class="cursor-pointer" @click="viewRoute(route.id)">
                        <p>View & Edit</p>
                      </div>
                    </button>
                  </el-dropdown-item>

                  <el-dropdown-item>
                    <div
                      v-if="route.isActive"
                      class="cursor-pointer"
                      @click="deactivateRoute(route.id)"
                    >
                      <p>Deactivate</p>
                    </div>
                    <div
                      v-else
                      class="cursor-pointer"
                      @click="activateRoute(route.id)"
                    >
                      <p>Activate</p>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
      class="mt-5"
      :total="totalRoutes"
      :pageNumber="pageNumber"
      @pageNumber="setNumDisplayLocation"
      @pageSize="pageSize"
    />
    <view-selected
      :showModal="viewSelected"
      @close-modal="viewSelected = false"
      :route="selectedRouteCities"
    >
    </view-selected>
    <delete-modal
      :showModal="isDeleteModal"
      :itemToDelete="itemToDelete"
      :deletingItem="deletingRoute"
      @close-modal="isDeleteModal = false"
      @delete-item="deleteRoute"
    />
  </div>
</template>

<script>
import pagination from "../../../../../UI/pagination.vue";
import viewSelected from "./viewSelectedCities.vue";
// import ActionDropdown from "./ActionDropdown";
export default {
  components: {
    pagination,
    viewSelected,
    // ActionDropdown,
  },
  data() {
    return {
      viewSelected: false,
      selectedRouteCities: [],
      selectedRowId: null,
      routes: [],
      loading: true,
      isDeleteModal: false,
      itemToDelete: "Route",
      deletingRoute: false,
      selectedRouteId: "",
      query: "",
      sortList: false,
      totalRoutes: 1,
      routesPerPage: 10,
      pageNumber: 1,
    };
  },
  computed: {
    filteredRoutes() {
      return this.filterArray(this.routes, this.query);
    },
    lists() {
      return this.sortList
        ? this.filteredRoutes
            .map((l) => l)
            .sort((a, b) => {
              var x = a.routeName.toLowerCase();
              var y = b.routeName.toLowerCase();
              return x < y ? -1 : x > y ? 1 : 0;
            })
        : this.filteredRoutes;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.routesPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.routesPerPage);
    },
    paginatedList() {
      return this.lists.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return {
        terminalType: "door-to-door",
        pageSize: this.routesPerPage,
        pageNum: this.pageNumber,
      };
    },
  },
  mounted() {
    this.getAllRoutes(this.setparams);
  },
  watch: {
    setparams() {
      this.loading = true;
      this.getAllRoutes(this.setparams);
    },
  },

  methods: {
    async activateRoute(routeId) {
      try {
        let payload = {
          payload: {
            isActive: true,
          },
        };
        await this.$_updateRoute(payload, routeId);
        this.getAllRoutes(this.setparams);
      } catch (error) {
        this.handleError();
      }
    },
    async deactivateRoute(routeId) {
      try {
        let payload = {
          payload: {
            isActive: false,
          },
        };
        await this.$_updateRoute(payload, routeId);
        this.getAllRoutes(this.setparams);
      } catch (error) {
        this.handleError();
      }
    },
    pageSize(val) {
      this.routesPerPage = val;
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    async getAllRoutes(params) {
      console.log("???????????????????????????????", params)
      try {
        let response = await this.$_getAllRoutes(params);
        // console.log(
        //   JSON.stringify(response.data.data.shippingServices, null, 2)
        // );
        this.loading = false;
        this.routes = response.data.data.shippingServices;
        this.totalRoutes = response.data?.data?.totalCount;
        console.log(response.data.data);
      } catch (error) {
        // this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async deleteRoute() {
      this.deletingRoute = true;

      try {
        let response = await this.$_deleteRoute(this.selectedRouteId);
        this.logResponse(response);
        this.generateToast("Route successfully Deleted", "success");
        this.getAllRoutes(this.setparams);
        this.deletingRoute = false;
        this.isDeleteModal = false;
      } catch (error) {
        this.handleError(error);
        this.deletingRoute = false;
      }
    },
    showDiactivateModal(routeId) {
      this.selectedRouteId = routeId;
      this.isDeleteModal = true;
    },

    viewRoute(routeId) {
      localStorage.setItem("routeId", routeId);
      this.$router.push({ name: "EditDoorToDoor" });
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style scoped>
.active {
  background: #09b78a1a;
  color: #09b78a;
  padding: 0.5rem;
  border-radius: 2px;
}

.inactive {
  background: #fcc2101a;
  color: #fcc210;
  padding: 0.5rem;
  border-radius: 2px;
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: flex-end;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  margin: 2rem 0;
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.table__action-btn {
  position: relative;
  padding: 0;
}

.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}

.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.table__action-option:hover {
  background: #fce4da;
}

.table__action-btn span {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }
  .table__btn-wrapper {
    width: 100%;
  }
  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
</style>
